import React from 'react';
import { Tooltip } from 'antd';
import { EditOutlined, CopyOutlined } from '@ant-design/icons';

export const getRegionGroupColumns = (
  handleEdit,
  handleCopy,
  currentuser,
  selectedOrg
) => [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    ellipsis: true,
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (name) => (
      <Tooltip title={name}>
        <span className="targeting-region__name-text">{name}</span>
      </Tooltip>
    ),
  },
  {
    title: 'Regions',
    dataIndex: 'regions',
    key: 'regions',
    align: 'left',
    width: 120,
    render: (regions) => (
      <span className="targeting-region__region-badge">
        {regions.length} region{regions.length !== 1 ? 's' : ''}
      </span>
    ),
  },
  {
    title: 'Preset',
    dataIndex: 'isPresetList',
    key: 'isPresetList',
    width: 80,
    align: 'left',
    sorter: (a, b) => (a.isPresetList ? 1 : -1) - (b.isPresetList ? 1 : -1),
    render: (isPresetList) => (
      <Tooltip title={isPresetList ? 'This is a preset group' : 'This is a custom group'}>
        <span className={`targeting-region__preset-badge${isPresetList ? ' targeting-region__preset-badge--yes' : ''}`}>
          {isPresetList ? 'Yes' : 'No'}
        </span>
      </Tooltip>
    ),
  },
  {
    title: '',
    key: 'actions',
    width: 80,
    align: 'right',
    render: (_, region) => {
      const isDisabled = currentuser.role.org.name !== selectedOrg.name;

      return (
        <div className="targeting-region__actions">
          <Tooltip title="Duplicate">
            <button
              className="targeting-region__action-btn"
              onClick={() => handleCopy(region)}
            >
              <CopyOutlined />
            </button>
          </Tooltip>
          <Tooltip title={isDisabled ? 'Cannot edit this group' : 'Edit'}>
            <button
              className={`targeting-region__action-btn${isDisabled ? ' targeting-region__action-btn--disabled' : ''}`}
              onClick={() => !isDisabled && handleEdit(region)}
              disabled={isDisabled}
            >
              <EditOutlined />
            </button>
          </Tooltip>
        </div>
      );
    },
  },
];
